import ElementConstants from '../../elements';

const PublicSiteInputGroupElements = {
	CHECKBOXES: {
		type: ElementConstants.INPUT_GROUPS.CHECKBOXES,
		label: 'Checkbox Group',
		hint: '',
		required: false,
		choices: [],
		customChoices: []
	},
	RADIO_BUTTONS: {
		type: ElementConstants.INPUT_GROUPS.RADIO_BUTTONS,
		label: 'Multiple Choice Question',
		hint: '',
		required: false,
		choices: [],
		customChoices: []
	},
	SELECT_MENU: {
		type: ElementConstants.INPUT_GROUPS.SELECT_MENU,
		tag: 'select',
		label: 'Question',
		hint: '',
		country: false,
		required: false,
		attributes: {
			placeholder: 'Please Select'
		},
		options: []
	},
	TABLE: {
		type: ElementConstants.INPUT_GROUPS.TABLE,
		label: 'Question',
		hint: '',
		required: false,
		rows: [],
		columns: [],
		style: 'radio'
	},
	RATING: {
		type: ElementConstants.INPUT_GROUPS.RATING,
		label: 'Question',
		hint: '',
		required: false,
		description: {
			lowest: 'Explain this rating',
			highest: 'Explain this rating'
		},
		choices: []
	}
}

export default PublicSiteInputGroupElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/elements/public-site/input-groups.js